import { Component, Event, EventEmitter, Prop, Watch, h } from '@stencil/core';

import { onQuestionAnswered } from '../../../actions/actions.answers';

@Component({
  tag: 'question-listselect',
  styleUrl: 'question-listselect.css',
})
export class QuestionListselect {
  @Prop() heading: string = '';
  @Prop() options = [];
  @Prop({ mutable: true }) value: string = null;
  @Prop() questionId: string = '';
  @Prop() subHeading: string = '';
  @Prop() isDisabled: boolean = false;
  @Prop() inputDefaultLabel: string = 'Select';
  @Prop() inputDefaultValue: string = null;
  @Event() valueChange: EventEmitter<string>;

  handleValueChange(evt) {
    this.value = evt.detail;
    this.valueChange.emit(evt.detail);
  }

  @Watch('value')
  onValueChange(newValue: string) {
    if (this.questionId) {
      onQuestionAnswered(this.questionId, newValue);
    }
  }

  render() {
    return (
      <input-select
        inputDefaultLabel={this.inputDefaultLabel}
        inputDefaultValue={this.inputDefaultValue}
        label={this.heading}
        options={this.options}
        value={this.value}
        isDisabled={this.isDisabled}
        onValueChange={(evt) => this.handleValueChange(evt)}
      />
    );
  }
}
